import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { I621Form } from 'legacy/lut/features/partner360/configuration'

import { CrudStore } from 'core/types/crudStore'

import { getJBPPartnerBasicInfoCrud } from './helpers/getJBPPartnerBasicInfoCrud'

type Data = Partial<Omit<I621Form, 'EntryId' | 'PartnerId'>>

export type TUpdatePartner360Configuration = Data & {
  EntryId: number
  PartnerId: string
  FYear: number
}

export const updatePartner360Configuration = async ({
  PartnerId,
  FYear,
  ...dataToUpdate
}: TUpdatePartner360Configuration) => {
  const partnerInfoCrud = getJBPPartnerBasicInfoCrud(
    ['PartnerId', PartnerId, 'FYear', FYear].join(',')
  )

  const completenessCrud = CrudStore.get(CrudStoreItemPartner360.CompletenessJBP)
  const [updated] = await partnerInfoCrud.update(
    {
      formId: '621',
      code: 'JBPBasicInformation',
    },
    [dataToUpdate]
  )
  await completenessCrud.update('0', [{ partnerId: PartnerId, updated: false }])

  return updated
}
